import { render } from "./addModuleDraftsOrder.vue?vue&type=template&id=e9a84bac&scoped=true"
import script from "./addModuleDraftsOrder.vue?vue&type=script&lang=js"
export * from "./addModuleDraftsOrder.vue?vue&type=script&lang=js"

import "./addModuleDraftsOrder.vue?vue&type=style&index=0&id=e9a84bac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a84bac"]])

export default __exports__